import { combineReducers } from 'redux';
import listings from './listings.reducer';

const hostReducer = combineReducers({
  listings,
});

export default hostReducer;
